import './App.css';
import { TodoWrapper } from './components/TodoWrapper';

function App() {
  return (
    <>
    <div className="App">
        <h1 id='main-heading'> To  Do  APP </h1>
        <hr id='line'></hr>
        <TodoWrapper />
    </div>
    </>
  );
}

export default App;
